import React from "react";
import { useNavigate } from "react-router-dom";
import FooterImage from "../../../assets/images/sdf.png";

const Footer = ({ t }) => {
  const navigate = useNavigate();
  const styles = {
    footerContainer: {
      backgroundColor: '#1a1a1a',
      background: 'linear-gradient(135deg, #1a1a1a 0%, #2c2c2c 100%)',
      color: '#ffffff',
      position: 'relative',
      overflow: 'hidden',
    },
    footerOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'radial-gradient(ellipse at center, rgba(52, 152, 219, 0.1) 0%, transparent 70%)',
      zIndex: 1,
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 20px',
      position: 'relative',
      zIndex: 2,
    },
    mainFooter: {
      padding: '60px 0 40px',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    },
    footerSection: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '40px',
      justifyContent: 'space-between',
    },
    aboutSection: {
      flex: '2',
      minWidth: '300px',
      maxWidth: '400px',
    },
    aboutTitle: {
      fontSize: '24px',
      fontWeight: '700',
      color: '#3498db',
      marginBottom: '20px',
      position: 'relative',
      paddingBottom: '10px',
    },
    aboutTitleUnderline: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '60px',
      height: '3px',
      background: 'linear-gradient(90deg, #3498db, #2980b9)',
      borderRadius: '2px',
    },
    aboutDescription: {
      fontSize: '15px',
      lineHeight: '1.7',
      color: '#b0b0b0',
      marginBottom: '0',
      textAlign: 'justify',
    },
    linksSection: {
      flex: '1',
      display: 'flex',
      gap: '40px',
      flexWrap: 'wrap',
    },
    linkColumn: {
      minWidth: '150px',
      flex: '1',
    },
    linkTitle: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#ffffff',
      marginBottom: '20px',
      position: 'relative',
      paddingBottom: '8px',
    },
    linkTitleUnderline: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '30px',
      height: '2px',
      backgroundColor: '#e74c3c',
      borderRadius: '1px',
    },
    linkList: {
      listStyle: 'none',
      padding: '0',
      margin: '0',
    },
    linkItem: {
      marginBottom: '12px',
      transition: 'all 0.3s ease',
    },
    linkText: {
      color: '#b0b0b0',
      fontSize: '14px',
      textDecoration: 'none',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      position: 'relative',
      paddingLeft: '0',
    },
    linkTextHover: {
      color: '#3498db',
      paddingLeft: '10px',
    },
    addressText: {
      color: '#b0b0b0',
      fontSize: '14px',
      marginBottom: '8px',
      lineHeight: '1.6',
    },
    bottomFooter: {
      padding: '25px',
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
    },
    bottomContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: '20px',
    },
    copyrightText: {
      color: '#888888',
      fontSize: '14px',
      margin: '0',
      flex: '1',
    },
    footerImageContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    footerImage: {
      maxHeight: '50px',
      width: 'auto',
      opacity: '0.8',
      transition: 'opacity 0.3s ease',
      filter: 'brightness(1.2)',
    },
    footerImageHover: {
      opacity: '1',
    },
    socialIcons: {
      display: 'flex',
      gap: '15px',
      marginTop: '20px',
    },
    socialIcon: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      color: '#b0b0b0',
      textDecoration: 'none',
      transition: 'all 0.3s ease',
      fontSize: '16px',
    },
    socialIconHover: {
      backgroundColor: '#3498db',
      color: '#ffffff',
      transform: 'translateY(-3px)',
    },
    // Responsive styles
    '@media (max-width: 768px)': {
      footerSection: {
        flexDirection: 'column',
        gap: '30px',
      },
      aboutSection: {
        maxWidth: '100%',
      },
      linksSection: {
        gap: '30px',
      },
      bottomContent: {
        flexDirection: 'column',
        textAlign: 'center',
        gap: '15px',
      },
    },
  };

  const SocialIcon = ({ icon, href = "#" }) => {
    const [isHovered, setIsHovered] = React.useState(false);

    return (
      <a
        href={href}
        style={{
          ...styles.socialIcon,
          ...(isHovered ? styles.socialIconHover : {}),
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <i className={icon} />
      </a>
    );
  };

  const LinkItem = ({ children, onClick }) => {
    const [isHovered, setIsHovered] = React.useState(false);

    return (
      <li style={styles.linkItem}>
        <span
          style={{
            ...styles.linkText,
            ...(isHovered ? styles.linkTextHover : {}),
          }}
          onClick={onClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {children}
        </span>
      </li>
    );
  };

  const [imageHovered, setImageHovered] = React.useState(false);

  return (
    <footer style={styles.footerContainer}>
      <div style={styles.footerOverlay} />

      <div style={styles.container}>
        {/* Main Footer Content */}
        <div style={styles.mainFooter}>
          <div style={styles.footerSection}>
            {/* About Section */}
            <div style={styles.aboutSection}>
              <h5 style={styles.aboutTitle}>
                {t("abus")}
                <div style={styles.aboutTitleUnderline} />
              </h5>
              <p style={styles.aboutDescription}>
                MadeInBangladesh.info, by TechKnowGram Limited, brings authentic Bangladeshi products to World with trust and quality.
                {/* Backed by 25+ years of global experience and ISO-certified excellence, we ensure a seamless shopping experience you can rely on. */}
              </p>

              {/* Social Icons */}
              <div style={styles.socialIcons}>
                <SocialIcon icon="fa fa-facebook" />
                <SocialIcon icon="fa fa-twitter" />
                <SocialIcon icon="fa fa-instagram" />
                <SocialIcon icon="fa fa-linkedin" />
                <SocialIcon icon="fa fa-youtube" />
              </div>
            </div>

            {/* Links Section */}
            <div style={styles.linksSection}>
              {/* Address Column */}
              <div style={styles.linkColumn}>
                <h5 style={styles.linkTitle}>
                  {t("addr")}
                  <div style={styles.linkTitleUnderline} />
                </h5>
                <p style={styles.addressText}>Suite 6B, House 8A/10, Doreen Tower, Road 13, Dhanmondi, Dhaka 1209</p>
                <p style={styles.addressText}>Bangladesh</p>
                <p style={styles.addressText}>Phone: +8801819250309</p>
                <p style={styles.addressText}>Email: info@techknowgram.com</p>
              </div>

              {/* My Account Column */}
              <div style={styles.linkColumn}>
                <h5 style={styles.linkTitle}>
                  {t("myAcc")}
                  <div style={styles.linkTitleUnderline} />
                </h5>
                <ul style={styles.linkList}>
                  <LinkItem onClick={() => navigate("/brands")}>{t("bra")}</LinkItem>
                  <LinkItem onClick={() => navigate("/gift-certificates")}>{t("gif")}</LinkItem>
                  <LinkItem onClick={() => navigate("/affiliates")}>{t("aff")}</LinkItem>
                  <LinkItem onClick={() => navigate("/specials")}>{t("spe")}</LinkItem>
                </ul>
              </div>

              {/* Customer Service Column */}
              <div style={styles.linkColumn}>
                <h5 style={styles.linkTitle}>
                  Customer Service
                  <div style={styles.linkTitleUnderline} />
                </h5>
                <ul style={styles.linkList}>
                  <LinkItem onClick={() => navigate("/contact-us")}>Contact Us</LinkItem>
                  <LinkItem onClick={() => navigate("/returns")}>Returns</LinkItem>
                  <LinkItem onClick={() => navigate("/site-map")}>Site Map</LinkItem>
                  <LinkItem onClick={() => navigate("/help-faq")}>Help & FAQ</LinkItem>
                </ul>
              </div>

            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div style={styles.bottomFooter}>
          <div style={styles.bottomContent}>
            <p style={styles.copyrightText}>
              {t("cop")} @ {new Date().getFullYear()} TechKnowGram Limited.
            </p>
            {/* <div style={styles.footerImageContainer}>
              <img
                src={FooterImage}
                alt="Footer Logo"
                style={{
                  ...styles.footerImage,
                  ...(imageHovered ? styles.footerImageHover : {}),
                }}
                onMouseEnter={() => setImageHovered(true)}
                onMouseLeave={() => setImageHovered(false)}
              />
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;